/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
  bearer: string;
};

type HookTuple = [
  response: vp.RTRWithdrawTransactionResponse,
  fetchData: (transactionID: string) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchRTRWithdrawTransaction: ApiHook = ({ api, bearer }: HookProps) => {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<string>();
  const [response, setResponse] = useState<vp.RTRWithdrawTransactionResponse>({
    TransactionID: '',
    TransactionStatus: vp.TransactionStatus.BLANK,
    TransactionDateTime: '',
    Amount: '',
    Currency: '',
    RecipientName: '',
    FinancialInstitutionNumber: '',
    HoldAmount: '',
    BranchTransitNumber: '',
    AccountNumber: '',
    ClientReferenceNumber: '',
    ProcessingDate: '',
    LastModified: '',
    GLCode: '',
    TransactionTypeCode: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: string) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen', true);

      const res = await api.fetchRTRWithdrawTransaction({ TransactionID: requestParams }, bearer, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false, 'loading some data', 'fullScreen', false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: string) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse({
        TransactionID: '',
        TransactionStatus: vp.TransactionStatus.BLANK,
        TransactionDateTime: '',
        Amount: '',
        Currency: '',
        RecipientName: '',
        FinancialInstitutionNumber: '',
        HoldAmount: '',
        BranchTransitNumber: '',
        AccountNumber: '',
        ClientReferenceNumber: '',
        ProcessingDate: '',
        LastModified: '',
        GLCode: '',
        TransactionTypeCode: '',
      });
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchRTRWithdrawTransaction);
